// extracted by mini-css-extract-plugin
module.exports = {"subcategoryCol":"style_subcategoryCol__20alP","subcategoryLink":"style_subcategoryLink__OCzYd","highlight":"style_highlight__1FiKE"};